module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "",
    attrs: {
      "id": ""
    }
  }, [_c('popwin', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "ctrl": _vm.ctrlWin
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "height": "50px",
      "width": "100%",
      "border": "0px solid red"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "margin-top": "10px",
      "margin-left": "10px",
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('radio', {
    ref: "idOSAn",
    staticStyle: {
      "height": "30px",
      "margin-right": "20px"
    },
    attrs: {
      "size": 18,
      "root": {
        obj: this
      },
      "grpName": 'GrpOS',
      "val": 'Android',
      "capt": 'Android',
      "myClick": _vm.onAndroidClick
    },
    model: {
      value: (_vm.curVer.avOs),
      callback: function($$v) {
        _vm.$set(_vm.curVer, "avOs", $$v)
      },
      expression: "curVer.avOs"
    }
  }), _vm._v(" "), _c('radio', {
    ref: "idOSWs",
    staticStyle: {
      "height": "30px",
      "margin-right": "20px"
    },
    attrs: {
      "size": 18,
      "root": {
        obj: this
      },
      "grpName": 'GrpOS',
      "val": 'Windows',
      "capt": 'Windows',
      "myClick": _vm.onWindowsClick
    },
    model: {
      value: (_vm.curVer.avOs),
      callback: function($$v) {
        _vm.$set(_vm.curVer, "avOs", $$v)
      },
      expression: "curVer.avOs"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "height": "50px",
      "width": "100%",
      "border": "0px solid red"
    }
  }, [_c('div', {
    staticClass: "SiftPanel"
  }, [_c('div', {
    staticClass: "Capt DIVNoSelect",
    staticStyle: {
      "flex": "0 0 auto",
      "margin-top": "-1px",
      "margin-left": "20px"
    }
  }, [_vm._v("应用")]), _vm._v(" "), _c('cselect', {
    key: _vm.appKey,
    staticStyle: {
      "position": "relative",
      "height": "30px",
      "min-width": "200px",
      "z-index": "999"
    },
    attrs: {
      "defv": _vm.curVer.avAppId,
      "ctrl": _vm.ctrlApp,
      "csData": _vm.dataApp,
      "onchange": _vm.onAppChange
    },
    model: {
      value: (_vm.curVer.avAppId),
      callback: function($$v) {
        _vm.$set(_vm.curVer, "avAppId", $$v)
      },
      expression: "curVer.avAppId"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "margin-top": "0px",
      "padding-left": "10px",
      "padding-right": "10px",
      "height": "32px",
      "line-height": "32px",
      "margin-left": "20px",
      "border-radius": "5px",
      "border": "1px solid blue",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.onNewFormShow
    }
  }, [_vm._v("添加版本")])], 1)]), _vm._v(" "), _c('table', {
    ref: "idVerList",
    staticClass: "CFTable",
    staticStyle: {
      "float": "left",
      "width": "98%",
      "margin-left": "10px",
      "margin-top": "10px"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32789e00","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/aiphoto/verMgr.vue
// module id = 775
// module chunks = 1